import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'gb',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    debug: process.env.NODE_ENV !== 'production',

    interpolation: {
      escapeValue: false // not needed for react!!
    },
    resources: {
      gb: {
        common: {
          saveText: 'Save',
          cancelText: 'Cancel',
          warningHeaderText: 'Warning',
          warningText: 'Are you sure you want to delete this?',
          yesText: 'Yes',
          noText: 'No',
          updateText: 'Update'
        },
        login: {
          loginButton: 'Login',
          demoButton: 'See demo',
          registerText: "Don't have account? <1>Create new one</1>",
          forgotPasswordText: 'Forgot password? <1>Reset it</1>',
          emailPlaceholder: 'E-mail address',
          passwordPlaceholder: 'Password',
          changePasswordSuccess: 'Password has been changed successfully!'
        },
        register: {
          emailPlaceholder: 'E-mail address',
          passwordPlaceholder: 'Password',
          confirmPasswordPlaceholder: 'Confirm password',
          registerButton: 'Register',
          loginText: 'Already have account? <1>Log in here</1>',
          successMessage: 'Registered successfully! Check your e-mail!'
        },
        forgotPassword: {
          forgotPasswordText: 'Enter your e-mail to reset password',
          forgotPasswordButton: 'Reset password',
          successMessage: 'Password has been reset. Please check your e-mail'
        },
        resetPassword: {
          resetPasswordText: 'Enter your new password',
          resetPasswordButton: 'Save password',
          successMessage:
            'Password has been changed! Please log in with your new password'
        },
        changePassword: {
          currentPasswordText: 'Current password',
          newPasswordText: 'New password',
          confirmNewPasswordText: 'Confirm new password',
          changePasswordText: 'Change password',
          currentPasswordWarningText: "Current password can't be empty",
          newPasswordWarningText: "New password can't be empty",
          confirmNewPasswordWarningText: "Confirm password can't be empty",
          notMatchPasswordWarningText: 'Passwords must match'
        },
        confirmEmail: {
          confirmEmailText: 'Your account is now active',
          backToLoginText: 'Go to login page'
        },
        navbar: {
          editUserText: 'Edit user',
          logoutButton: 'Logout',
          newHotelButton: 'Add new hotel',
          activityHeader: 'Activity'
        },
        sidebar: {
          dashboard: 'Dashboard',
          cleaning: 'Cleaning',
          settings: 'Settings',
          about: 'About'
        },
        hotelStructure: {
          noRoomText: 'There is no room, please add some <1>here</1>',
          floor: 'Floor',
          legend: 'Legend of cleanliness status of rooms'
        },
        roomBlock: {
          arrivalText: 'Guest will arrive',
          stayText: 'Guest is in the room',
          departureText: 'Guest will departure',
          scheduledCleaning: 'Cleaning is scheduled for this room'
        },
        occupancy: {
          occupancyText: 'Occupancy',
          adultsCount: 'Adults count',
          categoryAge1Count: 'Category age 1',
          categoryAge2Count: 'Category age 2',
          categoryAge3Count: 'Category age 3',
          notes: 'Notes',
          cleaningStatus: 'Status',
          clean: 'Clean',
          cleaning: 'Cleaning',
          cleaned: 'Cleaned',
          dirty: 'Dirty',
          header: 'Edit room'
        },
        room: {
          addRoomButton: 'Add room',
          addRoomGroupButton: 'Add room type',
          actionText: 'Action',
          nameText: 'Name',
          roomTypeText: 'Room type',
          roomsText: 'Rooms',
          roomTypesText: 'Room types',
          editRoomText: 'Edit room',
          editRoomTypeText: 'Edit room type',
          roomNameText: "Room's name",
          roomFloorText: 'Floor of the room',
          roomTypePickerText: 'Choose room’s type',
          roomTypeNameText: "Room type's name",
          addedRoomText: 'Room added',
          removedRoomText: 'Room removed',
          addedRoomTypeText: 'Room type added',
          removedRoomTypeText: 'Room type removed'
        },
        synchronization: {
          warningHeaderText: 'Warning',
          usernameText: 'Username',
          passwordText: 'Password',
          hotelsText: 'Hotels',
          warningText:
            'Changing hotels will delete {{hotels}} and all data connected to them. Do you want to continue?',
          synchronizationText: 'Synchronization',
          synchronizeButton: 'Synchronize',
          loginButton: 'Login',
          noSynchronizingText: 'You are not synchronized',
          synchronizingText: 'You are synchronizing with {{account}}',
          authenticationText: 'Authenticating...',
          synchronizingUserText: 'Synchronizing user...',
          synchronizingHotelText: 'Synchonizing hotels...',
          synchronizingRoomGroupText: 'Synchronizing room types...',
          synchronizingRoomsText: 'Synchronizing rooms...',
          synchronizingCompletedText: 'Synchronization completed',
          synchronizingErrorText: 'Synchronization error',
          synchronizationMessageText:
            "You have to use your administrator's credentials from dev.kwhotel.com.",
          warningUsernameText: "Username can't be empty",
          warningPasswordText: "Password can't be empty",
          warningHotelsText: 'You must select at least one hotel',
          invalidLoginOrPasswordText: 'Invalid login or password',
          synchronizationWarningText:
            'If you synchronize your hotel structure will be replaced with hotel structure from KWHotel.'
        },
        user: {
          usersText: 'Users',
          addUserButton: 'Add user',
          editUserText: ' Edit user',
          firstnameText: 'Firstname',
          surnameText: 'Surname',
          passwordText: 'Password',
          hotelsText: 'Hotels',
          hotelsPickerText: 'Choose hotels',
          userInfoText: 'Information'
        },
        cleaning: {
          cleaningListHeaderText: 'Scheduled cleaning',
          scheduleCleaningButton: 'Schedule cleaning',
          cleanerText: 'Cleaner',
          dateFromText: 'Date from',
          dateToText: 'Date to',
          roomsText: 'Rooms',
          scheduleCleaningHeaderText: 'Schedule cleaning',
          selectCleanerText: 'Select cleaner',
          selectDatesText: 'Select dates',
          selectRoomsToCleanText: 'Select rooms to clean',
          availableRoomsText: 'Available rooms',
          selectedRoomsText: 'Selected rooms',
          filterText: 'Filter...',
          showScheduledCheckboxText: 'Show already scheduled rooms',
          cleaningSavedText: 'Cleaning saved',
          selectCleanerText: 'You have to select cleaner',
          selectStartDateText: 'You have to select start date',
          selectEndDateText: 'You have to select end date',
          selectRoomText: 'You have to select at least one room',
          scheduleCleaningMessageText:
            "After clicking <1>Schedule cleaning</1> you can freely plan cleaning, pick dates and add rooms to the selected employee's list (via drag&drop). When you finish your work, save your changes."
        },
        hotel: {
          hotelWizardText: 'Hotel wizard',
          createHotelText: 'Create hotel',
          orText: 'or',
          synchronizeWithKWHotelText: 'Synchronize with KWHotel',
          hotelsNameText: "Hotel's name"
        },
        message: {
          welcomeMessageText:
            "<0>Welcome to HotelCleanApp!</0>It's nice that you are with us. You can now manage the cleanliness of your hotel. You have two options:<2><0>By clicking <1>Create hotel</1>, you will add rooms in the program yourself, and the application will work independently.</0><1>By clicking <1>Synchronize with KWHotel</1>, you will connect the application with your program. The rooms will be downloaded automatically, and the cleanliness will be constantly updated.</1></2>",
          dashboard: {
            info:
              'Click on the room in order to add information about arrivals, departures and notes for cleaning',
            tipsMessageText:
              '<0><0>In a moment you will create the structure of your property. All options are located in the <1>Configuration menu</1>:</0><1><0>Begin with creating groups of rooms (<1>Room types</1>),</0><1>Then create rooms in the application (<1>Rooms</1>),</1><2>Finally, add accounts for employees (<1>Users</1>).</2></1><2>After creating the room base and employees` accounts, you can start to create housekeeping plans (<2>Cleaning</2> tab). In the upper right corner you can choose the dates when you plan to refresh selected rooms.</2><3><0>Warning!</0> If you start synchronization with KWHotel Pro (<2>Synchronization</2> tab), the current structure will be replaced with the structure downloaded from the KWHotel Pro software.</3><4>To work!</4><5>Set up your HotelCleanApp >> <2>HERE</2></5></0>'
          },
          infoMessageText:
            '<0><0><0>Hotel CleanApp allows you to manage the housekeeping process in your property and monitor the progress of cleaning personnel in real time.</0></0><1>All rooms are visible on the homepage. Cleaned rooms are displayed in gray, the uncleaned rooms are in red, rooms that have been cleaned are in green, while currently cleaned rooms are orange.</1><2>If you use Hotel CleanApp independently from KWHotel Pro, first please add room groups and then rooms (<2>Configuration tab > Room types and Configuration > Rooms</2>). If your application synchronizes with KWHotel Pro - the room database has already been imported. </2><3>When using Hotel CleanApp independently, by clicking on the selected room you can set up arrivals or departures on a given day. If you are synchronized with KWHotel Pro, this data will be sent automatically and you will not be able to modify it from the application level.</3><4>In the room edition screen, you can add comments - they will be displayed to the employee who was assigned to clean the given room.</4><5>In the admin panel, by default, the homepage displays the status of rooms for today. In the upper right corner you may change a date.</5><6>Regardless of how you are using HotelCleanApp (independently or in sync with KWHotel Pro), it is necessary to add employee accounts (<1>Configuration tab > Users</1>).</6><7>If you already have a room base and employees - you can plan cleaning (Cleaning tab). After clicking <2>Schedule cleaning</2> you can freely choose dates and add rooms to the list for a given employee (using the drag and drop method). When you\'re done, save your changes. Scheduled cleanups can be edited or deleted using the option on the right side of the cleaning table (the table will be visible if you plan at least 1 cleaning).</7><8>In the mobile app, the basic view includes tiles with rooms planned for a given employee. Each tile also shows information about arrivals, departures and comments. After selecting one of the rooms, the employee can begin his work with the "Start cleaning button". Once it`s finished, he just presses the "Finish cleaning" button.</8><9><0>We wish you the pure pleasure of using Hotel CleanApp!</0></9></0>'
        },
        wallet: {
          walletHeaderText: 'Wallet',
          balanceText: 'Balance',
          chargeButtonText: 'Charge wallet',
          nextPaymentText: 'Next payment',
          estimatedPriceText: 'Estimated price',
          paymentHistoryText: 'Payment history',
          dateText: 'Date',
          typeText: 'Type',
          amountText: 'Amount',
          withdrawText: 'Withdraw',
          depositText: 'Deposit',
          chargeText: 'Charge',
          currency: 'EUR',
          paymentTypeText: 'Payment type',
          creditCardText: 'Credit card',
          changeButtonText: 'Change',
          walletHistoryText: 'Wallet history'
        }
      },
      pl: {
        common: {
          saveText: 'Zapisz',
          cancelText: 'Anuluj',
          warningHeaderText: 'Uwaga',
          warningText: 'Czy napewno chcesz to usunąć?',
          yesText: 'Tak',
          noText: 'Nie',
          updateText: 'Zaktualizuj'
        },
        login: {
          loginButton: 'Zaloguj',
          demoButton: 'Zobacz demo',
          registerText: 'Nie masz konta? <1>Zarejestruj się</1>',
          forgotPasswordText: 'Zapomniałeś/aś hasła? <1>Zresetuj je</1>',
          emailPlaceholder: 'Adres e-mail',
          passwordPlaceholder: 'Hasło',
          changePasswordSuccess: 'Hasło zostało zmienione'
        },
        register: {
          emailPlaceholder: 'Adres e-mail',
          passwordPlaceholder: 'Hasło',
          confirmPasswordPlaceholder: 'Powtórz hasło',
          loginText: 'Masz już konto? <1>Zaloguj się</1>',
          registerButton: 'Zarejestruj',
          successMessage:
            'Zarejestrowano pomyślnie. Sprawdź e-maila by aktywować konto'
        },
        forgotPassword: {
          forgotPasswordText: 'Wpisz adres e-mail by zresetować hasło',
          forgotPasswordButton: 'Zresetuj hasło',
          successMessage: 'Hasło zostało zresetowane. Sprawdź e-maila'
        },
        resetPassword: {
          resetPasswordText: 'Podaj swoje nowe hasło',
          resetPasswordButton: 'Zapisz hasło',
          successMessage: 'Hasło zostało zmienione'
        },
        changePassword: {
          currentPasswordText: 'Obecne hasło',
          newPasswordText: 'Nowe hasło',
          confirmNewPasswordText: 'Potwierdź nowe hasło',
          changePasswordText: 'Zmień hasło',
          currentPasswordWarningText: 'Obecne hasło nie może być puste',
          newPasswordWarningText: 'Nowe hasło nie może być puste',
          confirmNewPasswordWarningText:
            'Potwierzenie hasła nie może być puste',
          notMatchPasswordWarningText: 'Hasła muszą być takie same'
        },
        confirmEmail: {
          confirmEmailText: 'Twoje konto jest teraz aktywne',
          backToLoginText: 'Powrót na stronę główną'
        },
        navbar: {
          editUserText: 'Edytuj użytkownika',
          logoutButton: 'Wyloguj',
          newHotelButton: 'Stwórz nowy hotel',
          activityHeader: 'Akywność'
        },
        sidebar: {
          dashboard: 'Dashboard',
          cleaning: 'Sprzątanie',
          settings: 'Ustawienia',
          about: 'Informacje'
        },
        hotelStructure: {
          noRoomText: 'Nie znaleziono pokoi, prosze dodać je <1>tutaj</1>',
          floor: 'Piętro',
          legend: 'Legenda statusów czystości pokoi'
        },
        roomBlock: {
          arrivalText: 'Gość przyjedzie',
          stayText: 'Gość jest w pokoju',
          departureText: 'Gość wyjeżdża',
          scheduledCleaning: 'Zaplanowane sprzątanie dla tego pokoju'
        },
        occupancy: {
          occupancyText: 'Status zajętości pokoju',
          adultsCount: 'Ilość dorosłych',
          categoryAge1Count: 'Kategoria wiekowa 1',
          categoryAge2Count: 'Kategoria wiekowa 2',
          categoryAge3Count: 'Kategoria wiekowa 3',
          notes: 'Notatka',
          cleaningStatus: 'Status czystości pokoju',
          clean: 'Czysty',
          cleaning: 'Sprzątany',
          cleaned: 'Posprzątany',
          dirty: 'Brudny',
          header: 'Edytowanie pokoju'
        },
        room: {
          addRoomButton: 'Dodaj pokój',
          addRoomGroupButton: 'Dodaj typ pokoi',
          actionText: 'Akcja',
          nameText: 'Nazwa',
          roomTypeText: 'Typ pokoju',
          roomsText: 'Pokoje',
          roomTypesText: 'Typy pokoi',
          editRoomText: 'Edytuj pokój',
          editRoomTypeText: 'Edytuj typ pokoi',
          roomNameText: 'Nazwa pokoju',
          roomFloorText: 'Piętro pokoju',
          roomTypePickerText: 'Wybierz typ pokoju',
          roomTypeNameText: 'Nazwa typu pokoju',
          addedRoomText: 'Dodano pokój',
          removedRoomText: 'Usunięto pokój',
          addedRoomTypeText: 'Dodano typ pokoi',
          removedRoomTypeText: 'Usunięto typ pokoi'
        },
        synchronization: {
          warningHeaderText: 'Uwaga',
          warningText:
            'Zmiana hoteli usunie {{hotels}} i wszystkie dane z nimi powiązane. Czy chcesz kontynuować?',
          usernameText: 'Login',
          passwordText: 'Hasło',
          hotelsText: 'Hotele',
          synchronizationText: 'Synchronizacja',
          synchronizeButton: 'Synchronizuj',
          loginButton: 'Zaloguj',
          noSynchronizingText: 'Nie jesteś zsynchronizowany',
          synchronizingText: 'Synchronizujesz się z kontem {{account}}',
          authenticationText: 'Uwierzytelnianie...',
          synchronizingUserText: 'Synchronizacja użytkownika...',
          synchronizingHotelText: 'Synchronizacja hoteli...',
          synchronizingRoomGroupText: 'Synchronizacja typów pokoi...',
          synchronizingRoomsText: 'Synchronizacja pokoi...',
          synchronizingCompletedText: 'Synchronizacja zakończona',
          synchronizingErrorText: 'Błąd synchronizacji',
          synchronizationMessageText:
            'Należy użyć danych logowania administatora do panelu dev.kwhotel.com.',
          warningUsernameText: 'Nazwa użytkownika nie może być pusta',
          warningPasswordText: 'Hasło nie może być puste',
          warningHotelsText: 'Musisz wybrać przynajmniej jeden hotel',
          invalidLoginOrPasswordText: 'Niepawidłowy login lub hasło',
          synchronizationWarningText:
            'Jeśli uruchomisz synchronizację, stworzona przez Ciebie struktura pokoi zostanie zastąpiona przez stukturę pobraną z programu KWHotel.'
        },
        user: {
          usersText: 'Użytkownicy',
          addUserButton: 'Dodaj użytkownika',
          editUserText: 'Edytuj użytkownika',
          firstnameText: 'Imię',
          surnameText: 'Nazwisko',
          passwordText: 'Hasło',
          hotelsText: 'Hotele',
          hotelsPickerText: 'Wybierz hotele',
          userInfoText: 'Informacje'
        },
        cleaning: {
          cleaningListHeaderText: 'Zaplanowane sprzątania',
          scheduleCleaningButton: 'Zaplanuj sprzątanie',
          cleanerText: 'Obsługa',
          dateFromText: 'Data od',
          dateToText: 'Data do',
          roomsText: 'Pokoje',
          scheduleCleaningHeaderText: 'Zaplanuj sprzątanie',
          selectCleanerText: 'Wybierz obsługę',
          selectDatesText: 'Wybierz daty',
          selectRoomsToCleanText: 'Wybierz pokoje do posprzątania',
          availableRoomsText: 'Dostępne pokoje',
          selectedRoomsText: 'Wybrane pokoje',
          filterText: 'Filtruj...',
          showScheduledCheckboxText: 'Pokaż pokoje przypisane',
          scheduleCleaningMessageText:
            'Po kliknięciu <1>Zaplanuj sprzątanie</1> możesz swobodnie planować sprzątanie, wybierać daty oraz dodawać pokoje do listy dla danego pracownika (metodą przeciągnij i upuść). Kiedy skończysz pracę, zapisz zmiany.',
          cleaningSavedText: 'Zapisano sprzątanie',
          selectCleanerText: 'Musisz wybrać obługę',
          selectStartDateText: 'Musisz wybrać początkową datę',
          selectEndDateText: 'Musisz wybrać końcową datę',
          selectRoomText: 'Musisz wybrać przynajmniej jeden pokój'
        },
        hotel: {
          hotelWizardText: 'Kreator hotelu',
          createHotelText: 'Stwórz hotel',
          orText: 'lub',
          synchronizeWithKWHotelText: 'Synchronizuj z KWHotelem',
          hotelsNameText: 'Nazwa hotelu'
        },
        message: {
          welcomeMessageText:
            '<0>Witaj w HotelCleanApp!</0> Miło, że z nami jesteś. Możesz teraz zarządzać czystością swojego obiektu. Masz dwie możliwości: <2><1>Klikając <1>Stwórz hotel</1>, samodzielnie dodasz pokoje w programie, a aplikacja będzie działała niezależnie.</1><1>Klikając <1>Synchronizuj z KWHotelem</1>, połączysz aplikację ze swoim programem. Pokoje zostaną pobrane automatycznie, a statusy czystości będą na bieżąco aktualizowane.</1></2>',

          dashboard: {
            info:
              'Kliknij na pokój, aby dodać informacje o przyjazdach i wyjazdach oraz komentarze do sprzątania',
            tipsMessageText:
              '<0><0>Za chwilę zaczniesz tworzyć strukturę swojego hotelu. Wszystkie opcje, które pozwolą Ci sprawnie rozpocząć pracę znajdują się w menu <1>Ustawienia</1>:</0><1><0>zacznij od stworzenia typów pokoi (<1>Typy pokoi</1>)</0><1>następnie utwórz w aplikacji pokoje (<1>Pokoje</1>)</1><2>dodaj konta dla pracowników (<1>Użytkownicy</1>)</2></1><2>Po utworzeniu struktury pokoi i kont dla pracowników, możesz zacząć tworzyć plany sprzątania (zakładka <2>Sprzątanie</2>). W prawym górnym rogu możesz wybierać daty, na które planujesz odświeżanie wybranych pokoi.</2><3><0>Uwaga!</0> Jeśli uruchomisz synchronizację (zakładka <2>Synchronizacja</2>), stworzona przez Ciebie struktura zostanie zastąpiona przez stukturę pobraną z programu KWHotel.</3><4>Do dzieła!</4><5>Skonfiguruj swój HotelCleanApp >> <2>TUTAJ</2></5></0>'
          },
          infoMessageText:
            '<0><0><0>Aplikacja HotelCleanApp pozwala zarządzać procesem sprzątania w Twoim obiekcie oraz na bieżąco monitorować postępy prac personelu sprzątającego.</0></0><1>Na stronie głównej widoczne są wszystkie Twoje pokoje. Pokój czysty wyświetlany jest w kolorze szarym, pokój brudny w kolorze czerwonym, pokój posprzątany w kolorze zielonym, natomiast na pomarańczowo zaznaczane są pokoje, w których aktualnie trwa sprzątanie.</1><2>Jeśli korzystasz z aplikacji niezależnie od programu KWHotel, w pierwszym kroku dodaj grupy pokoi, a następnie pokoje (zakładka <2>Ustawienia >Typy pokoi i Ustawienia > Pokoje</2>). Jeśli Twoja aplikacja współpracuje z programem KWHotel – baza pokoi została już zaimportowana. </2><3>Podczas korzystania z aplikacji niezależnie, klikając na wybranym pokoju możesz manulanie ustawiać przyjazdy lub wyjazdy w danym dniu. Jeśli aplikacja jest połączona z programem KWHotel, dane te będą przesyłane automatycznie i nie będzie możliwości ich modyfikowania z poziomu aplikacji.</3><4>W oknie edycji danego pokoju możesz dodawać komentarze – będą one wyświetlane pracownikowi, któremu przydzielisz pokój do sprzątania.</4><5>Strona główna w panelu administratora domyślnie wyświetla stan pokoi w bieżącym dniu. W prawym górnym rogu dostępny jest przycisk umożliwiający zmianę daty. </5><6>Bez względu na wariant korzystania z HotelCleanApp (niezależnie bądź w synchronizacji z KWHotel), niezbędne jest dodanie kont pracowników (zakładka <1>Ustawienia > Użytkownicy</1>). </6><7>Jeśli posiadasz już bazę pokoi i pracowników – możesz zaplanować sprzątanie (zakładka Sprzątanie). Po kliknięciu <2>Zaplanuj spotkanie</2> możesz swobodnie planować sprzątanie, wybierać daty oraz dodawać pokoje do listy dla danego pracownika (metodą przeciągnij i upuść). Kiedy skończysz pracę, zapisz zmiany. Zaplanowane sprzątania możesz edytować lub usuwać używając opcji znajdujących się po prawej stronie tabeli sprzątań (tabela będzie widoczna, jeśli zaplanujesz minimum 1 sprzątanie).</7><8>W aplikacji mobilnej dla personelu sprzątającego, podstawowy widok obejmuje kafelki z zaplanowanymi dla danego pracownika pokojami, a w nich wyświetlane są informacje o przyjazdach, wyjazdach oraz komentarze. Po wybraniu jednego z pokoi, pracownik ma możliwość rozpoczęcia sprzątania – Start cleaning. Po zakończeniu pracy powinien nacisnąć klawisz Finish cleaning. W wyjątkowych sytuacjach może skorzystać z przycisku Abort cleaning, wtedy pokój pozostanie oznaczony jako brudny.</8><9><0>Życzymy czystej przyjemności korzystania z aplikacji HotelCleanApp!</0></9></0>'
        },
        wallet: {
          walletHeaderText: 'Portfel',
          balanceText: 'Stan konta',
          chargeButtonText: 'Doładuj portfel',
          nextPaymentText: 'Następna płatność',
          estimatedPriceText: 'Szacowane koszty',
          paymentHistoryText: 'Historia płatności',
          dateText: 'Data',
          typeText: 'Typ',
          amountText: 'Kwota',
          withdrawText: 'Pobranie',
          depositText: 'Deponowanie',
          chargeText: 'Subskrybcja',
          currency: 'PLN',
          paymentTypeText: 'Typ płatności',
          creditCardText: 'Karta kredytowa',
          changeButtonText: 'Zmień',
          walletHistoryText: 'Historia portfela'
        }
      }
    },
    react: {
      wait: true
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/helpers/i18n.js